'use client';

import type { ContentField, ContentLeaf } from '@eliadmin/core/src/api/content-fields/content-fields-types';
import { contentFieldKey } from '@eliadmin/core/src/api/content-fields/public-content-fields';
import { ContentFieldBlock } from '@eliadmin/core/src/components/content-fields/content-fields';
import { hasVisibleContentLeaf } from '@eliadmin/core/src/utils/content-fields';
import { ProductContentGallery } from './product-content-gallery';

function ProductContentLeaf({ field }: { field: ContentLeaf }) {
  return field.type === 'images' ? (
    <ProductContentGallery images={field.images} name={field.name} />
  ) : (
    <ContentFieldBlock field={field} module="products" showTitle={false} />
  );
}

/** Keep the shared safe text/file renderer; only product-tab galleries have a compact preview. */
export function ProductContentField({ field }: { field: ContentField }) {
  if (field.type !== 'group') return <ProductContentLeaf field={field} />;
  const key = contentFieldKey('products', field.id);

  return (
    <section className="ea-content-fields__field flex w-full flex-col gap-4" data-content-field={key}>
      {field.items.filter(item => item.fields.some(hasVisibleContentLeaf)).map(item => (
        <div key={`${key}:item:${item.id}`} className="ea-content-fields__item flex flex-col gap-4">
          {item.fields.filter(hasVisibleContentLeaf).map(leaf => (
            <div key={`${key}:item:${item.id}:field:${leaf.id}`}>
              <h3 className="mb-2 font-semibold">{leaf.name}</h3>
              <ProductContentLeaf field={leaf} />
            </div>
          ))}
        </div>
      ))}
    </section>
  );
}
